function convert_quantity_metres(){

  // parse the value into a float:
  centimetre_quantity = parseFloat( $("#quantity").val() );
  
   // check if we have a number
  if (isNaN(centimetre_quantity)) return 0;	
    
  // convert cm to metres, and round
  var metre_quantity = centimetre_quantity / 100;
  
  // round to nearest 5 cm
  metre_quantity = (Math.round(metre_quantity * 20) / 20).toFixed(2);
  
  // remove extraneous zeros:
  if (metre_quantity % Math.round(metre_quantity).toFixed(0) == 0) metre_quantity = Math.round(metre_quantity).toFixed(0);
  
    // set the value of the quantity box:
  $("#per_metre_quantity").text(metre_quantity);
  
  return 1;
  
}

function convert_quantity_centimetres(){

  // parse the value into a float:
  centimetre_quantity = parseFloat( $("#quantity").val() );
  
  // check if we have a number
  if (isNaN(centimetre_quantity)) return 0;
  
  // impose a minimum quantity of 25 cm:
  if (centimetre_quantity < 25) {
    var metre_quantity = centimetre_quantity;
    centimetre_quantity = metre_quantity * 100;
    query_message = "Oops, did you mean " + centimetre_quantity + " centimetres (" +  metre_quantity + " metres)?";
    
    var query = confirm( query_message );
    
	if (query !== true) {
    	// reset the value of the quantity box:
  		$("#quantity").val(100);
    	convert_quantity_metres();
    	return 0;
    }

  }

  // round to nearest 25 cm  
  centimetre_quantity = centimetre_quantity / 5;
  centimetre_quantity = Math.round(centimetre_quantity);
  centimetre_quantity = centimetre_quantity * 5;
  
    // set the value of the quantity box:
  $("#quantity").val(centimetre_quantity);  

  return 1;
  
}

function handle_metres(){
  
  // parse the metres value into a float:
  var metre_quantity = parseFloat( $("#metre_quantity").val() );
 
  // check if we have a number
  if (isNaN(metre_quantity)) return 0;
  
  // impose a minimum quantity of 25 cm:
  if (metre_quantity < 0.25) metre_quantity = 0.25;

  // convert metres to cm
  var centimetre_quantity = metre_quantity * 100;
  
  // round to nearest 5 cm
  centimetre_quantity = (Math.round(centimetre_quantity * 5) / 5);

  // set the value of the centimetre quantity box:
  $("#quantity").val(centimetre_quantity);
  
  
  
}